import styled from 'styled-components';
import withResponsive from 'shared/helpers/withResponsive';
import { Flex } from 'shared/layout';

export const ScriptBlockWrapper = withResponsive(styled(Flex)`
	margin: ${({ hasMargin, theme }) => hasMargin && `0 -${theme.spacings[4]}`};
	width: 100%;
`);
